import NotificationWrapper from "@AppBuilderLib/features/notifications/ui/NotificationWrapper";
import {useCustomTheme} from "@AppBuilderLib/shared/ui/theme/useCustomTheme";
import {useThemeFavicon} from "@AppBuilderLib/shared/ui/theme/useThemeFavicon";
import AppBuilderPage from "@AppBuilderShared/pages/appbuilder/AppBuilderPage";
import "@mantine/charts/styles.css";
import {MantineProvider} from "@mantine/core";
import "@mantine/core/styles.css";
import {Notifications} from "@mantine/notifications";
import "@mantine/notifications/styles.css";
import * as ShapeDiverViewerSession from "@shapediver/viewer.session";
import * as ShapeDiverViewerViewport from "@shapediver/viewer.viewport";
import "AppBuilderBase.css";
import {useEffect} from "react";
import packagejson from "../package.json";

// log the SDK version directly to the console
// this is independent of the logger settings within the app
console.log(`ShapeDiver App Builder SDK v${packagejson.version}`);

declare global {
	interface Window {
		SDV: typeof ShapeDiverViewerSession & typeof ShapeDiverViewerViewport;
	}
}

export default function AppBuilderBase() {
	useEffect(() => {
		window.SDV = Object.assign(
			{},
			ShapeDiverViewerSession,
			ShapeDiverViewerViewport,
		);
	}, []);

	const {theme, resolver} = useCustomTheme();
	useThemeFavicon(theme);

	return (
		<MantineProvider
			defaultColorScheme="auto"
			forceColorScheme={theme.other?.forceColorScheme}
			theme={theme}
			cssVariablesResolver={resolver}
		>
			<Notifications notificationMaxHeight={1000} />
			<NotificationWrapper>
				<AppBuilderPage />
			</NotificationWrapper>
		</MantineProvider>
	);
}
